import { useEffect } from 'react';
export const API = process.env.REACT_APP_API_BASE_URL!;
interface Metadata {
  title: string;
  description: string;
  keywords: string;
  ogTitle: string;
  ogDescription: string;
  ogImage: string;
}

const API_BASE_URL = `${API}/metadata`;

interface Props {
  page: string;
}

const MetaUpdater: React.FC<Props> = ({ page }) => {
  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/${page}`);
        if (!res.ok) throw new Error('Failed to fetch metadata');
        const data: Metadata = await res.json();

        document.title = data.title || 'Shahlpo';

        const updateMeta = (name: string, content: string) => {
          let tag = document.querySelector(`meta[name="${name}"]`);
          if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('name', name);
            document.head.appendChild(tag);
          }
          tag.setAttribute('content', content);
        };

        const updateOg = (property: string, content: string) => {
          let tag = document.querySelector(`meta[property="${property}"]`);
          if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('property', property);
            document.head.appendChild(tag);
          }
          tag.setAttribute('content', content);
        };

        updateMeta('description', data.description);
        updateMeta('keywords', data.keywords);
        updateOg('og:title', data.ogTitle);
        updateOg('og:description', data.ogDescription);
        updateOg('og:image', data.ogImage);
      } catch (error) {
        console.error('Metadata error:', error);
      }
    };

    fetchMetadata();
  }, [page]);

  return null;
};

export default MetaUpdater;
